import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { GraphQLClient } from "graphql-request";
import Footer from "../Components/footer";
import Header from "../Components/header";
import Skeleton from "react-loading-skeleton";
import { InputFieldOptions } from "../Components/InputField";
import "react-loading-skeleton/dist/skeleton.css";
import { Helmet } from "react-helmet";

const API_URL = process.env.REACT_APP_API_URL;

const getPage = async () => {
  const client = new GraphQLClient(
    "https://api-eu-central-1-shared-euc1-02.hygraph.com/v2/clweq2m6a000001w67aqzeh7x/master"
  );

  const query = `query MyQuery {
  rivistes(orderBy: dataPubblicazione_DESC) {
    id
    numeroRivista
    prezzo
    slugRivista
    copertina {
      fileName
      id
      url
    }
      sommario{
        text
    }
  }
}

  `;

  try {
    const data = await client.request(query);
    return data.rivistes;
  } catch (error) {
    console.error("Error fetching issues:", error);
    throw error;
  }
};

const Page = () => {
  const { slug } = useParams();
  const [rivistes, setRivistes] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredRiviste, setFilteredRiviste] = useState([]);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const rivisteData = await getPage();
        await setRivistes(rivisteData);
        await setFilteredRiviste(rivisteData);
        console.log(rivisteData);
        const imagePromises = rivisteData.map((abbonamento) => {
          return new Promise((resolve) => {
            const img = new Image();
            img.src = abbonamento.copertina.url;
            img.onload = resolve;
            img.onerror = resolve;
          });
        });

        await Promise.all(imagePromises);
        await setIsLoading(false);
      } catch (error) {
        console.error("Error fetching page:", error);
      }
    };

    fetchPage();
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    applyFilter(event.target.value);
  };

  const applyFilter = (search) => {
    const filteredData = rivistes.filter((item) => {
      const titolo = item.numeroRivista || "";
      const sommario = item.sommario.text || "";

      return (
        titolo.toLowerCase().includes(search.toLowerCase()) ||
        sommario.toLowerCase().includes(search.toLowerCase())
      );
    });

    setFilteredRiviste(filteredData); // Mostra tutti gli utenti che corrispondono al termine di ricerca
  };

  if (isLoading) {
    return (
      <div className="flex flex-col min-h-screen">
        <Header />
        <Helmet>
          <title>Modellistica International - Arretrati</title>
          <meta
            name="description"
            content="Scopri il mondo dell'aeromodellismo e modellismo con Modellistica International, la rivista dedicata agli appassionati."
          />
          <meta
            name="keywords"
            content="modellistica, aeromodelli, modellistica international, modellismo, abbonamenti modellismo, rivista modellistica abbonamento"
          />
        </Helmet>

        <div className="flex flex-col items-center py-8 px-6 lg:px-12 text-left bg-white min-h-screen">
          <h1 className="text-4xl font-bold mb-8 text-gray-800">Arretrati</h1>

          <div className="flex-1 p-6 w-full">
            <div className="flex justify-between items-center mb-6">
              <div className="w-full h-10">
                <Skeleton
                  width={"50%"}
                  height={50}
                  className="p-5 border border-gray-300 shadow-sm "
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4 md:grid-cols-5 w-full text-center">
              {Array.from({ length: 10 }).map((_, index) => (
                <div key={index}>
                  <Skeleton
                    key={index}
                    width={"80%"}
                    height={"220px"}
                    className="text-center mt-10"
                  />
                  <Skeleton width={"70%"} height={10} className="mt-5" />
                  <Skeleton width={"70%"} height={10} className="mb-1" />
                  <Skeleton width={"10%"} height={10} className="" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Helmet>
        <title>Modellistica International - Arretrati</title>
        <meta
          name="description"
          content="Scopri il mondo dell'aeromodellismo e modellismo con Modellistica International, la rivista dedicata agli appassionati."
        />
        <meta
          name="keywords"
          content="modellistica, aeromodelli, modellistica international, modellismo, abbonamenti modellismo, rivista modellistica abbonamento"
        />
      </Helmet>
      <Header />
      <div className="flex flex-col items-center py-8 px-6 lg:px-12 text-left bg-white min-h-screen">
        <h1 className="text-4xl font-bold mb-8 text-gray-800">Arretrati</h1>
        <div className="flex-1 p-6">
          <div className="flex justify-between items-center mb-6">
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearchChange}
              className="p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-400 w-1/2 bg-white text-gray-700"
              placeholder="🔍 Cerca un numero o un articolo in particolare..."
            />
          </div>

          <div className="grid grid-cols-2 gap-4 md:grid-cols-5">
            {filteredRiviste.map((rivista) => (
              <Link
                key={rivista.id}
                to={`/arretrati/${rivista.slugRivista}`}
                className="text-center mt-4"
              >
                <div
                  key={rivista.id}
                  className="flex flex-col p-4 rounded items-center"
                >
                  <img
                    src={rivista.copertina.url}
                    alt={rivista.copertina.fileName}
                    className="w-full h-auto mx-auto max-w-full hover:scale-110 transition duration-500 ease-in-out"
                    style={{
                      maxHeight: "240px",
                      maxWidth: "180px",
                      minHeight: "90px",
                      minWidth: "90px",
                    }}
                  />

                  <p className=" font-bold mt-4">{rivista.numeroRivista}</p>
                  <p className="font-bold text-gray-600 mt-2">
                    € {rivista.prezzo}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Page;
